<template>
  <svg
    class="animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      class="bg-circle"
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM2.99535 12C2.99535 16.9731 7.02687 21.0047 12 21.0047C16.9731 21.0047 21.0047 16.9731 21.0047 12C21.0047 7.02687 16.9731 2.99535 12 2.99535C7.02687 2.99535 2.99535 7.02687 2.99535 12Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
    <path
      d="M4.75062 2.43723C6.25972 1.29321 8.01816 0.522581 9.88216 0.188364C11.7462 -0.145853 13.6628 -0.0341727 15.4754 0.514275C17.2879 1.06272 18.945 2.03237 20.311 3.34392C21.677 4.65548 22.7132 6.27172 23.3349 8.06048L20.5012 9.04536C20.0349 7.70379 19.2577 6.49161 18.2332 5.50794C17.2087 4.52427 15.9659 3.79704 14.6065 3.38571C13.2471 2.97437 11.8096 2.89061 10.4116 3.14127C9.01362 3.39194 7.69479 3.96991 6.56296 4.82793L4.75062 2.43723Z"
      fill="currentColor"
    />
  </svg>
</template>